import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============ Global credentials: 'include' for backend requests ============
// Ensures httpOnly auth cookies are sent on every API call to REACT_APP_BACKEND_URL,
// so that after login (which sets an httpOnly cookie) the session is maintained
// without needing to keep the JWT in localStorage (XSS defense).
(() => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  if (!BACKEND_URL || typeof window === "undefined" || !window.fetch) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      // Include credentials for backend API calls (same-origin in prod, but explicit is safer)
      if (url.startsWith(BACKEND_URL) || url.startsWith("/api")) {
        if (!init.credentials) init = { ...init, credentials: "include" };
      }
    } catch (_) { /* no-op */ }
    return originalFetch(input, init);
  };
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
